import { Col, Layout as TheLayout, Row } from 'antd';
import Header from './Header';

const Layout = ({
   children,
   header,
   headerTitle,
   isWebview = 'false',
   noHeader = false,
}) => {
   return (
      <TheLayout>
         {!noHeader && (
            <Header type={header} title={headerTitle} isWebview={isWebview} />
         )}
         <TheLayout.Content>
            <Col span={24} style={{ maxWidth: 500 }}>
               <Row style={{ height: '100%', flexDirection: 'column' }}>
                  {children}
               </Row>
            </Col>
         </TheLayout.Content>
      </TheLayout>
   );
};

export default Layout;
